import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Shows only user-facing warnings, avoiding technical warning overload.
 */
@Component({
  selector: 'app-rea-import-user-warnings',
  templateUrl: './rea-import-user-warnings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReaImportUserWarningsComponent {
  @Input()
  public warnings: string[] = [];
}
